import { render, staticRenderFns } from "./upload-pic-input.vue?vue&type=template&id=4bfa7dd8"
import script from "./upload-pic-input.vue?vue&type=script&lang=js"
export * from "./upload-pic-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports